import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { COPY } from '../presentationCopy';
import { PRES, TYPE } from '../chrome';
import PageKindInfo from './PageKindInfo';

interface LibraryLinkedBannerProps {
  sourceMissing?: boolean;
  canDetach?: boolean;
  busy?: boolean;
  onDetach?: () => void;
}

const LibraryLinkedBanner: React.FC<LibraryLinkedBannerProps> = ({
  sourceMissing,
  canDetach,
  busy,
  onDetach,
}) => (
  <Box
    role="status"
    aria-label={sourceMissing ? COPY.librarySourceMissing : COPY.libraryLinkedBanner}
    sx={{
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      gap: 1.5,
      px: 2,
      py: 1,
      bgcolor: sourceMissing ? PRES.surfaceSunken : PRES.navy,
      color: sourceMissing ? PRES.textPrimary : PRES.white,
      borderBottom: `3px solid ${PRES.gold}`,
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Typography sx={{
        fontFamily: TYPE.ui,
        ...TYPE.body,
        fontWeight: 650,
        color: sourceMissing ? PRES.textPrimary : PRES.white,
      }}>
        {sourceMissing ? COPY.librarySourceMissing : COPY.libraryLinkedBanner}
      </Typography>
      <Typography sx={{
        fontFamily: TYPE.ui,
        ...TYPE.caption,
        color: sourceMissing ? PRES.textSecondary : 'rgba(255,255,255,0.78)',
      }}>
        {sourceMissing ? COPY.librarySourceMissingHelp : COPY.libraryLinkedHelp}
      </Typography>
    </Box>
    <PageKindInfo text={COPY.pageKindLibraryInfo} tone={sourceMissing ? 'light' : 'dark'} />
    {!sourceMissing && canDetach && onDetach && (
      <Button
        size="small"
        disabled={busy}
        onClick={onDetach}
        sx={{
          flexShrink: 0,
          textTransform: 'none',
          bgcolor: PRES.gold,
          color: PRES.navyDeep,
          fontWeight: 700,
          boxShadow: 'none',
          '&:hover': { bgcolor: PRES.gold, opacity: 0.92 },
        }}
      >
        {COPY.libraryDetach}
      </Button>
    )}
  </Box>
);

export default LibraryLinkedBanner;
